module.exports = __webpack_public_path__ + "img/FIN.de64c27e.png";